import { FC, memo } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';

import { AppRoutes } from '@/common/interfaces';
import { FallbackedLayout } from '@/common/layouts';

import { useGetOauthUrlSearchConsoleAccountsQuery } from '@/modules/DomainsApi';
import { useUpdateTokenStatus } from '@/modules/DomainsApi/SearchConsole/hooks';

import { ThirdStepView } from './ThirdStepView';

interface Props {
  searchConsoleAccountId: string;
}

export const ThirdStepCreateContainer: FC<Props> = memo(({ searchConsoleAccountId }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    data: oauthUrlData,
    error: oauthUrlError,
    isLoading: isOauthUrlLoading,
    isError: isOauthUrlError,
    isSuccess: isOauthUrlSuccess
  } = useGetOauthUrlSearchConsoleAccountsQuery(searchConsoleAccountId ?? '')({
    enabled: !!searchConsoleAccountId
  });

  useUpdateTokenStatus({
    navigate,
    queryClient,
    searchConsoleAccountId,
    searchConsoleAccountUrlRequestSuccess: isOauthUrlSuccess
  });

  const handleOpenOAuthWindow = (url: string) => {
    window.open(url, '_blank', 'location=yes,height=600,width=450,scrollbars=yes,status=yes');
  };

  const handleBack = () => {
    navigate(AppRoutes.DomainsApiSearchConsoleAccounts);
  };

  return (

    <FallbackedLayout
      data={ oauthUrlData }
      isLoading={ isOauthUrlLoading }
      isError={ isOauthUrlError }
      error={ oauthUrlError }
    >
      {
        (oauthUrl) => (
          <>
            <ThirdStepView
              password={ oauthUrl.password }
              url={ oauthUrl.url }
              handleOpenOAuthWindow={ handleOpenOAuthWindow }
              handleBack={ handleBack }
            />
          </>
        )
      }
    </FallbackedLayout>
  );
});
